// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"oba-z","colorTextValue":"pba-z","swatches":"qba-z","collapseLink":"rba-z","isCollapsed":"sba-z","dropdown":"tba-z","disabled":"uba-z"};